<template>

    <header>

        <div class="container">

            <div class="row">

                <div class="col text-center brand-logo">

                    <a :href="'/'"><img src="/images/logo.white.png" alt="WHY Logotype"></a>

                </div>

            </div>

            <div class="row navigation">

                <div class="col-12 d-none d-sm-none d-md-block">

                    <div class="row">

                        <div class="col">
                            <ul>

                                <li :class="{'active': activeNavigationItem === '/'}">
                                    <a :href="'/'" class="link">Blog</a>
                                </li>
                                <li :class="{'active': activeNavigationItem === '/pages/about' || activeNavigationItem === '/pages/about/'}">
                                    <a :href="'/pages/about'" class="link">O nas</a>
                                </li>
                                <li  :class="{'active': activeNavigationItem === '/search'}">
                                    <a href="javascript:" onclick="openSearch()"><i class="fal fa-search"></i></a>
                                </li>
                            </ul>
                        </div>

                        <div class="col-4 text-center">
                            <ul class="collections">
                                <li v-for="collection in collections" :class="{'active': activeNavigationItem === '/collection/' + collection.seo.handle || activeNavigationItem === '/collection/' + collection.seo.handle + '/'}">
                                    <a :href="'/collection/'+collection.seo.handle">{{collection.title}}</a>
                                </li>
                            </ul>
                        </div>

                        <div class="col text-right">
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/Why.si.blog/"><i class="fab fa-facebook"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/thats.why.si/"><i class="fab fa-instagram"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/channel/UCnbpRZpBWa85d-wUrXaOlRg"><i class="fab fa-youtube"></i></a>
                                </li>
                                <li>
                                    <a :href="'/newsletter'" class="newsletter btn btn-danger"><i class="fal fa-envelope"></i> &nbsp;E-novice</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>

                <div class="col-12 d-block d-sm-block d-md-none">

                    <div style="padding: 0" class="navbar-head navbar navbar-dark box-shadow mb-2">
                        <div style="padding: 0" class="container d-flex justify-content-between">
                            <button class="search navbar-brand d-flex align-items-center" onclick="openSearch()">
                                <i class="fal fa-search"></i>
                            </button>
                            <button class="navbar-toggler" type="button" data-toggle="collapse"
                                    data-target="#navbarHeader"
                                    aria-controls="navbarHeader" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                        </div>
                    </div>

                    <div class="navbar-content collapse no-gutters pb-2" id="navbarHeader">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="row">

                                        <div class="col-12 text-center">
                                            <ul class="collections">
                                                <li :class="{'active': activeNavigationItem === '/'}"
                                                    data-toggle="collapse"
                                                    data-target="#navbarHeader"
                                                    aria-controls="navbarHeader" aria-expanded="false" aria-label="Toggle navigation">
                                                    <a :href="'/'" class="link">Blog</a>
                                                </li>
                                                <li :class="{'active': activeNavigationItem === '/pages/about' || activeNavigationItem === '/pages/about/' }"
                                                    data-toggle="collapse"
                                                    data-target="#navbarHeader"
                                                    aria-controls="navbarHeader" aria-expanded="false" aria-label="Toggle navigation">
                                                    <a :href="'/pages/about'" class="link">O nas</a>
                                                </li>
                                                <li v-for="collection in collections" :class="{'active': activeNavigationItem === '/collection/' + collection.seo.handle}">

                                                    <a data-toggle="collapse"
                                                                 data-target="#navbarHeader"
                                                                 aria-controls="navbarHeader" aria-expanded="false" aria-label="Toggle navigation"
                                                                 :href="'/collection/'+collection.seo.handle">

                                                        {{collection.title}}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-12 text-center">
                                            <ul>
                                                <li>
                                                    <a href="https://www.facebook.com/Why.si.blog"><i class="fab fa-facebook"></i></a>
                                                </li>
                                                <li>
                                                    <a href="https://www.instagram.com/thats.why.si/"><i class="fab fa-instagram"></i></a>
                                                </li>
                                                <li>
                                                    <a href="https://www.youtube.com/channel/UCnbpRZpBWa85d-wUrXaOlRg"><i class="fab fa-youtube"></i></a>
                                                </li>
                                                <li class="mb-4">
                                                    <a :href="'/newsletter'" class="newsletter btn btn-danger"
                                                                 data-toggle="collapse"
                                                                 data-target="#navbarHeader"
                                                                 aria-controls="navbarHeader" aria-expanded="false" aria-label="Toggle navigation"
                                                    ><i class="fal fa-envelope"></i> &nbsp;E-novice</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </header>

</template>

<script>

    import {mapState, mapActions} from 'vuex'

    export default {

        computed: {

            ...mapState([
                'collections',
                'activeNavigationItem'
            ]),
        },

        watch:{

            $route (to, from){

                this.setActiveNavigationItem(to.path);
            }
        },

        methods: {

            ...mapActions([
               'getCollections',
                'setActiveNavigationItem'
            ]),

            loadCollections: function() {

                this.getCollections();
            }

        },

        mounted: function() {

            this.setActiveNavigationItem(this.$route.path);
            this.loadCollections();
        }
    }
</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/layout/Header.vue